// extracted by mini-css-extract-plugin
export default {"fullscreenWrapper":"gRVaCPVMNN1g19a4w3Gy2g=="};